/**
 * API base aday listesi.
 *
 * Dev modda (baseUrl="") **yalnız proxy üzerinden** (relative path) gideriz —
 * cookie SameSite uyumu için page origin ile API origin aynı olmalı.
 * Eskiden burada `http://127.0.0.1:8000` fallback'i vardı; cross-origin AJAX
 * yapıyordu ve tarayıcı `SameSite=lax` cookie'leri göndermediği için F5
 * sonrası logout oluyordu. Fallback kaldırıldı.
 *
 * Üretimde (baseUrl dolu): aynı URL ve localhost/127.0.0.1 alternatifi.
 */
export function buildApiCandidates(baseUrl) {
  const candidates = [baseUrl];
  if (baseUrl) {
    if (baseUrl.includes("127.0.0.1")) {
      candidates.push(baseUrl.replace("127.0.0.1", "localhost"));
    } else if (baseUrl.includes("localhost")) {
      candidates.push(baseUrl.replace("localhost", "127.0.0.1"));
    }
  }
  return [...new Set(candidates)];
}

/** Ağ veya 5xx: bir sonraki tabanı dene. 4xx (şifre vb.) genelde tekrarlanmaz. */
export function shouldFailoverBackendRequest(err) {
  const s = err?.response?.status;
  if (err?.response == null) return true;
  if (typeof s === "number" && s >= 500 && s < 600) return true;
  if (s === 408 || s === 429) return true;
  return false;
}
